<template>
  <div class="l-default-no-valid">
    <Header :content="contentHeaderFooter" v-if="isShowHeader" />
    <router-view></router-view>
  </div>
</template>

<script>
import { get } from 'lodash'
import Header from '@/components/Header'

export default {
  name: 'DefaultLayout',
  components: {
    Header
  },
  data() {
    return {
      scTimer: 0,
      scY: 0,
      headerNo: this.$route.meta.header,
      footerNo: this.$route.meta.footer,
      contentHeaderFooter: null,
      listShowHeader: ['/pages/no-valid-plan-menu']
    }
  },
  created() {
    this.getData()
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  computed: {
    isShowHeader() {
      return this.listShowHeader?.includes(this.$route.path)
    }
  },
  methods: {
    handleScroll() {
      if (this.scTimer) return
      this.scTimer = setTimeout(() => {
        this.scY = window.scrollY
        clearTimeout(this.scTimer)
        this.scTimer = 0
      }, 100)
    },
    toTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },
    getData() {
      this.$repositories('cms')
        .getHeaderFooter()
        .then((response) => {
          this.contentHeaderFooter = get(response, 'data')
        })
    }
  },
  watch: {
    $route() {
      this.footerNo = this.$route.meta.footer
    }
  }
}
</script>

<style lang="scss" scoped>
@import './styles.scss';
</style>
